import { FormSelectOption } from '@/modules/core/form/models/FormSelectOption';
import ClientGroupFormService from '@/modules/ta/clientgroup/services/ClientGroupFormService';
import { AppModule } from '@/modules/core/app/constants/app.constants';
import { getters } from '@/modules/core/app/helpers/store';

export class ClientGroupSelectOption extends FormSelectOption {
  constructor(config = {}) {
    const userSettings = getters.session.getUserSettings();
    const placeholder = userSettings.isModuleAvailable(AppModule.BRAND_PACKAGE)
      ? i18n.$t('Select a {label}', { label: i18n.$t('Campaign Group') })
      : i18n.$t('Select a {label}', { label: i18n.$t('Client Group') });
    super({
      placeholder,
      ...config,
    });
  }

  /**
   * @param params
   * @returns {Promise<*>}
   */
  getData(params) {
    return ClientGroupFormService.getValues({ fields: 'id,name', ...params });
  }
}
